export const PBX_REGIONS = Object.freeze({
  USA: "USA",
  CAN: "CAN",
  EU: "EU",
  GBR: "GBR",
  AUS: "AUS",
  IN: "IN",
  CHN: "CHN",
});

export const PBX_TYPES = Object.freeze({
  CONFERENCE: "CONFERENCE",
  CONFERENCE_ACCESS: "CONFERENCE_ACCESS",
  CLICK_TO_DIAL: "CLICK_TO_DIAL",
  MOBILE: "MOBILE",
  MOBILE_TRIAL: "MOBILE_TRIAL",
  ONE_NUMBER_ACCESS: "ONE_NUMBER_ACCESS",
  RMX: "RMX",
  SOLO_ACCOUNT: "SOLO_ACCOUNT",
  VIRTUAL_OFFICE: "VIRTUAL_OFFICE",
  HYBRID: "HYBRID",
});

export const PBX_CLASS_TYPES = Object.freeze({
  SMB: "SMB",
  ENTERPRISE: "ENTERPRISE",
});

export const PBX_STATUSES = Object.freeze({
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
});

export const PBX_DIAL_PLAN_RULE_SETS = Object.freeze({
  DOMESTIC: "DOMESTIC",
  INTERNATIONAL: "INTERNATIONAL",
  EMERGENCYONLY: "EMERGENCYONLY",
  CUSTOM1: "CUSTOM1",
  CUSTOM2: "CUSTOM2",
  CUSTOM3: "CUSTOM3",
});

export const PBX_COLLISIONS = Object.freeze({
  NONE: "NONE",
  EXISTING_PBX_COLLISION: "EXISTING_PBX_COLLISION",
  WORK_ORDER_PBX_COLLISION: "WORD_ORDER_PBX_COLLISION",
});
